import styles from '../styles/Logo.module.css';
import logo from '../assets/logo.png'; // Or use "/logo.png" if placed in /public

const Logo = () => {
    return (
        <section className={styles.logo_modul} id="home">
            <img src={logo} alt="Dreamgarage Logo" className={styles.logo} />
        </section>
    );
};

export default Logo;
